import React from 'react';
import {useOutlet} from 'reconnect.js';
import * as User from 'rev.sdk.js/Actions/User';
import Config from '../../../data.json';
import AdminLayout from '../AdminLayout';
import SiteNavBar from '../SiteNavBar';
import ProfileLayout from '../ProfileLayout';
import SiteFooter from '../SiteFooter';
import CheckoutLayout from '../CheckoutLayout';
import useFacebookPixel from '../../Hooks/useFacebookPixel';
import useGoogleAnalytics from '../../Hooks/useGoogleAnalytics';
import useLayoutInit from '../../Hooks/useLayoutInit';
import PleaseWait from '../PleaseWait';
import useIsInApp from 'rev.sdk.js/Hooks/useIsInApp';
import useSiteNavBar from '../../Hooks/useSiteNavBar';
import useSiteFooter from '../../Hooks/useSiteFooter';
import * as CustomLayout from '../../Utils/CustomLayout';
import LoginRequired from '../LoginRequired';
import * as AppActions from '../../AppActions';

function Layout(props) {
  const {children, location} = props;
  const isInApp = useIsInApp();
  const [initialized, setInitialized] = React.useState(false);

  useFacebookPixel({pixelId: Config.pixelId});
  useGoogleAnalytics({gaId: Config.gaId, gtmId: Config.gtmId});

  const {extraElement} = useLayoutInit(props);
  const {showNavbar} = useSiteNavBar({
    location: props.location,
    pageContext: props.pageContext,
  });
  const {showFooter} = useSiteFooter({
    location: props.location,
    pageContext: props.pageContext,
  });

  React.useEffect(() => {
    const initialize = async () => {
      let result = false;

      try {
        result = await AppActions.autoLogin();
      } catch (ex) {
        console.log('autoLogin ex', ex);
        User.logout();
      }

      setInitialized(true);
    };

    if (!initialized) {
      initialize();
    }
  }, [location.pathname, initialized]);

  /* refresh token */
  React.useEffect(() => {
    if (initialized) {
      let timer = setInterval(async () => {
        console.log('auto refresh access token');
        try {
          await AppActions.autoLogin();
        } catch (ex) {
          console.log('autoLogin ex', ex);
          User.logout();
        }
      }, 7080000); // 1 hour 58 minute

      return () => clearInterval(timer);
    }
  }, [location.pathname, initialized]);

  if (!initialized) {
    return <PleaseWait title="自動登入中" />;
  }

  return (
    <>
      {CustomLayout.renderHtmlHelmet({location})}
      <LoginRequired {...props}>
        <AdminLayout location={location}>{children}</AdminLayout>
      </LoginRequired>
    </>
  );
}

export default Layout;
